
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
  },
}
